/* eslint-disable max-len */
/* eslint-disable import/no-useless-path-segments */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react';
import '../scss/function-sounce-picture.scss';

import { round } from 'mathjs';
import { styled } from '@mui/system';
import { LinearProgress } from '@mui/material';
import Color from '@/tool/color';
import moBility from '../../../store/mobility';
import { isEmpty } from 'lodash';

interface IProps { }
interface IState { }

const LeftChart = (props: IProps, state: IState) => {
  const [active, setActive] = useState<number>(0);
  const { roleList, roleLeftActive } = moBility;
  const sum = (arr: any) => {
    if (arr.length > 0) {
      return arr.reduce((prev: any, curr: any, idx: any, arr: any) => {
        return prev + curr;
      });
    }
    return 0;
  };

  const showList = useMemo(() => {
    if (!isEmpty(roleList)) {
      if (roleLeftActive === 'role') {
        return roleList.inflow?.category_details;
      }
      return roleList.inflow?.industry_details;
    }
    return [];
  }, [roleLeftActive, roleList])
  const leftHeight = (val: number) => {
    const list: any = [];
    showList?.forEach((item: { ratio: number; }) => {
      list.push(item.ratio);
    });
    return `${(val / sum(list)) * (list.length * 50 + 40)}px`;
  };

  const getPictureHeight = useMemo(() => {
    if (!isEmpty(showList)) {
      const list: any = [];
      showList?.forEach((item: { ratio: number; }) => {
        list.push(item.ratio);
      });

      let val: number = 0;
      for (let i = 0; i < active + 1; i += 1) {
        if (i === active) {
          val += (list[i] / 2);
        } else {
          val += list[i];
        }
      }
      return `${(val / sum(list)) * (list.length * 50) - active * 50 + 4}px`;
    }
    return '0px';
  }, [showList])

  useEffect(() => {
    return () => { };
  }, []);

  const DProgress = styled(LinearProgress)({
    // width: '120px',
    borderRadius: '4px',
    height: '8px',
    backgroundColor: Color.blackColor(0.04),
  });

  return (
    <section className="function-sounce-picture">
      <section className="function-sounce-picture-left">
        {
          showList?.map((item: any, i: number) => (
            <p
              style={{
                backgroundImage: active === i ?
                  'url(https://file.smartsalary.cn/web-img%402.0/market/image/talentactive.png)' :
                  'url(https://file.smartsalary.cn/web-img%402.0/market/image/talent.png)',
                width: '100px',
                height: leftHeight(item.ratio),
                backgroundSize: '100% 100%',
              }}
              key={`${i.toString()}`}
              onMouseEnter={() => { setActive(i); }}
              onMouseLeave={() => { setActive(0); }}
              className="left-items" />
          ))
        }
        <img src="https://file.smartsalary.cn/web-img%402.0/market/image/blue.png" alt=""
          className="inflow-sounce-picture-left-picture"
          style={{ height: `${getPictureHeight}`, top: `${active * 50 + 36}px` }} />
      </section>
      <section className="function-sounce-picture-mid">
        {
          showList?.map((item: any, i: number) => (
            <section
              className={active === i ? 'mid-items1' : 'mid-items'}
              key={`${i.toString()}`}>
              <p
                key={`${i.toString()}q`}>
                <b
                  style={{
                    background: active === i ? Color.primary : 'none',
                    borderColor: active === i ? Color.primary : Color.ccc,

                  }} />
                <span className="mid-item-name">{item.category_name || item.industry_name}</span>
                <span>{`${round(item.ratio * 100, 1)}%`}</span>
              </p>
              <section style={{ paddingLeft: 30 }}>
                <DProgress variant="determinate"
                  value={round(item.ratio * 100, 1)} className="in" />
              </section>
            </section>
          ))
        }
        <p className="mid-item-left-connect"
          style={{
            top: `${active * 50 + 56}px`,
            background: Color.primaryColor(0.3),
          }} />
      </section>
    </section>
  );
};

export default observer(LeftChart);
